module.exports = __webpack_public_path__ + "static/media/SettingsActive.752cf034.png";